import CookieStorage from './CookieStorage';

/**
 * @class
 * @classdesc Хранение данных в LocalStorage. Если браузером не поддерживается, пытается сохранять в Cookie
 * @inheritDoc
 * @extends module:storage.CookieStorage
 * @memberOf module:storage
 */
class LocalStorage extends CookieStorage {

    constructor(key) {
        super(key);
    }

    get available() {
        return !!(window && window.localStorage);
    }

    get async () {
        return false;
    }

    load(callback = null) {

        // fallback to cookies for browsers without localStorage support
        if (!this.available) {
            return super.load(callback);
        }

        let data = window.localStorage.getItem(this.key);
        if (callback instanceof Function) {
            callback(data);
        }
        return data;
    }

    save(data, callback = null) {

        // fallback to cookies for browsers without localStorage support
        if (!this.available) {
            return super.save(data, callback);
        }

        window.localStorage.setItem(this.key, data);
        if (callback instanceof Function) {
            callback();
        }
    }
}

export default LocalStorage;